import Vue from 'vue';
import googleMapsClient from '@/api/google-maps/streetView';
import { computeHeading } from '@/common/utils/geometry';

export function buildStreetViewPreviewImageUrl(location: string, width = 400, height = 200): string {
  return `https://maps.googleapis.com/maps/api/streetview?size=${width}x${height}&location=${location}&source=outdoor&key=${Vue.prototype.$tenant?.googleMapsApiKey}`;
}

/**
 * Creates a google maps street view URL for the given address.
 * @param {string} address - The address to use as the viewing point.
 * @returns {string} - The google maps street view URL.
 */
 export async function buildStreetViewUrl(address: string, latitude: number, longitude: number): Promise<string> {
  const metaData = await googleMapsClient.getStreetViewImageMetaData(address);

  if (!metaData?.location) {
    return `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${latitude},${longitude}`
  }

  const heading = computeHeading(metaData.location.lat, metaData.location.lng, latitude, longitude)

  return `https://www.google.com/maps/@?api=1&map_action=pano&pano=${metaData?.pano_id}&heading=${heading}`;
}
